import { app, Component, ojs, payload } from "modular-openscriptjs";
import { $e } from "../../../ojs.events";

const h = app("h");
const broker = app("broker");

export default class QuickOrderCard extends Component {
    render(initialText, ...args) {
        return h.div(
            {
                class: "quick-order-card p-4 rounded-4 shadow-sm text-white position-relative overflow-hidden mb-5",
                style: "background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%);",
                role: "button",
                listeners: {
                    click: () => {
                        broker.send(
                            $e.product.needs.creation,
                            payload({ initialText }),
                        );
                    },
                },
            },
            // Decorative background elements
            h.div({
                class: "position-absolute",
                style: "width: 150px; height: 150px; background: rgba(255, 255, 255, 0.1); border-radius: 50%; top: -50px; right: -50px;",
            }),
            h.div({
                class: "position-absolute",
                style: "width: 100px; height: 100px; background: rgba(255, 255, 255, 0.05); border-radius: 50%; bottom: -20px; left: -20px;",
            }),

            h.div(
                { class: "position-relative z-index-1" },
                h.div(
                    { class: "row align-items-center g-3" },
                    h.div(
                        { class: "col-12 col-md-8" },
                        h.h3(
                            { class: "fw-bold mb-2" },
                            "Can't find what you're looking for?",
                        ),
                        h.p(
                            { class: "mb-0 opacity-90 fs-sm" },
                            "Tell us what you need! Just type it out, we'll handle the rest",
                        ),
                    ),
                    h.div(
                        { class: "col-12 col-md-4 text-md-end" },
                        h.button(
                            {
                                class: "btn btn-white btn-lg rounded-pill px-4 fw-bold shadow-sm d-inline-flex align-items-center gap-2",
                                style: "background: white; color: #6366f1; border: none;",
                            },
                            h.i({ class: "bi bi-stars" }),
                            "Add It",
                        ),
                    ),
                ),
            ),
            ...args,
        );
    }
}

ojs(QuickOrderCard);
